/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_European_TeletextInputs */



/**
* | output |
* | --- |
* | "European Teletext" |
*
* @param {Standards_Preset_European_TeletextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_european_teletext = /** @type {((inputs?: Standards_Preset_European_TeletextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_European_TeletextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "de") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "it") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "ru") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "es") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "ja") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "hi") return /** @type {LocalizedString} */ ("European Teletext")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("European Teletext")
	return /** @type {LocalizedString} */ ("European Teletext")
});